import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { HiUserPlus, HiInformationCircle } from 'react-icons/hi2';
import { register } from '../../services/api';

const ROLES = ['admin', 'staff', 'customer'];

const EMPTY_FORM = { name: '', email: '', password: '', confirm_password: '', role: 'staff', phone: '' };

export default function Users() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.password.trim()) {
      toast.error('Name, Email, and Password are required.');
      return;
    }
    if (form.password !== form.confirm_password) {
      toast.error('Passwords do not match.');
      return;
    }
    if (form.password.length < 6) {
      toast.error('Password must be at least 6 characters.');
      return;
    }
    setSaving(true);
    try {
      await register({
        name: form.name,
        email: form.email,
        password: form.password,
        role: form.role,
        phone: form.phone || undefined,
      });
      toast.success('User account created successfully.');
      setSuccess(`User "${form.name}" (${form.role}) has been created.`);
      setForm(EMPTY_FORM);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to create user account.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="content-area">
      <div className="page-header">
        <h1 className="page-title">User Management</h1>
      </div>

      {/* Info banner */}
      <div className="alert alert-info" style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '1.5rem' }}>
        <HiInformationCircle style={{ flexShrink: 0, marginTop: '0.1rem', fontSize: '1.1rem' }} />
        <div>
          <strong>Note:</strong> User accounts can also be created automatically when adding a Customer or Employee by checking the "Create Login Account" option on those pages.
          Use this form to manually create admin or staff accounts.
        </div>
      </div>

      <div style={{ maxWidth: '520px' }}>
        <div className="card">
          <div className="card-header">
            <span className="card-title">Create User Account</span>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="card-body">
              {success && (
                <div className="alert alert-success" style={{ marginBottom: '1rem' }}>{success}</div>
              )}
              <div className="form-group">
                <label className="form-label">Full Name *</label>
                <input
                  className="form-control"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Enter full name"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email *</label>
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Phone</label>
                <input
                  className="form-control"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="Enter phone number"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Role</label>
                <select className="form-control" name="role" value={form.role} onChange={handleChange}>
                  {ROLES.map((r) => (
                    <option key={r} value={r}>{r.charAt(0).toUpperCase() + r.slice(1)}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Password *</label>
                <input
                  className="form-control"
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Min. 6 characters"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm Password *</label>
                <input
                  className="form-control"
                  type="password"
                  name="confirm_password"
                  value={form.confirm_password}
                  onChange={handleChange}
                  placeholder="Re-enter password"
                  required
                />
              </div>
            </div>
            <div className="modal-footer" style={{ justifyContent: 'flex-end' }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => { setForm(EMPTY_FORM); setSuccess(''); }}
              >
                Reset
              </button>
              <button type="submit" className="btn btn-primary" disabled={saving}>
                <HiUserPlus /> {saving ? 'Creating...' : 'Create Account'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
